/*
|-----------------------------------------------------|
|                 |  91 - 180 | 181 - 270 | 271 - 366 |
|-----------------|-----------|-----------|-----------|
| 1000 - 1999.99  | 1 (10)    | 2 (11)    | 3 (12)    |
|-----------------|-----------|-----------|-----------|
| 2000 - 2999.99  | 4 (13)    | 5 (14)    | 6 (15)    |
|-----------------|-----------|-----------|-----------|
| 3000 - 3999.99  | 7 (16)    | 8 (17)    | 9 (18)    |
|-----------------------------------------------------|
*/

export default [
    {
        deposit_id: 277,
        currency: 'USD',
        term_min: 91,
        term_max: 180,
        sum_min: 1000,
        sum_max: 1999.99,
        capitalized: true,
        removal: true,
        refill: true,
        rollover: false,
        rate: 1,
        capitalized_rate: 10,
    },
    {
        deposit_id: 277,
        currency: 'USD',
        term_min: 181,
        term_max: 270,
        sum_min: 1000,
        sum_max: 1999.99,
        capitalized: true,
        removal: true,
        refill: true,
        rollover: false,
        rate: 2,
        capitalized_rate: 11,
    },
    {
        deposit_id: 277,
        currency: 'USD',
        term_min: 271,
        term_max: 366,
        sum_min: 1000,
        sum_max: 1999.99,
        capitalized: true,
        removal: true,
        refill: true,
        rollover: false,
        rate: 3,
        capitalized_rate: 12,
    },
    {
        deposit_id: 277,
        currency: 'USD',
        term_min: 91,
        term_max: 180,
        sum_min: 2000,
        sum_max: 2999.99,
        capitalized: true,
        removal: true,
        refill: true,
        rollover: false,
        rate: 4,
        capitalized_rate: 13,
    },
    {
        deposit_id: 277,
        currency: 'RUR',
        term_min: 181,
        term_max: 270,
        sum_min: 2000,
        sum_max: 2999.99,
        capitalized: true,
        removal: true,
        refill: true,
        rollover: false,
        rate: 5,
        capitalized_rate: 14,
    },
    {
        deposit_id: 277,
        currency: 'USD',
        term_min: 271,
        term_max: 366,
        sum_min: 2000,
        sum_max: 2999.99,
        capitalized: true,
        removal: true,
        refill: true,
        rollover: false,
        rate: 6,
        capitalized_rate: 15,
    },
    {
        deposit_id: 277,
        currency: 'USD',
        term_min: 91,
        term_max: 180,
        sum_min: 3000,
        sum_max: 3999.99,
        capitalized: true,
        removal: true,
        refill: true,
        rollover: false,
        rate: 7,
        capitalized_rate: 16,
    },
    {
        deposit_id: 277,
        currency: 'USD',
        term_min: 181,
        term_max: 270,
        sum_min: 3000,
        sum_max: 3999.99,
        capitalized: true,
        removal: true,
        refill: true,
        rollover: false,
        rate: 8,
        capitalized_rate: 17,
    },
    {
        deposit_id: 277,
        currency: 'USD',
        term_min: 271,
        term_max: 366,
        sum_min: 3000,
        sum_max: 3999.99,
        capitalized: true,
        removal: true,
        refill: true,
        rollover: false,
        rate: 9,
        capitalized_rate: 18,
    },
];
